/**
 * Mensagens de erro do Clerk traduzidas e humanizadas para o português.
 */

const EM_PORTUGUES: Record<string, string> = {
  session_exists:
    "Já existe uma conta conectada neste navegador. Saia dela primeiro para entrar com outra.",
  identifier_already_signed_in:
    "Esta conta já está conectada neste navegador.",

  form_identifier_exists: "Este e-mail já tem conta no LummiChat. Tente entrar.",
  form_identifier_not_found: "Não encontramos nenhuma conta com este e-mail.",
  form_password_incorrect: "Senha incorreta.",
  form_password_validation_failed: "Senha incorreta.",
  form_password_length_too_short: "A senha precisa ter no mínimo 8 caracteres.",
  form_password_pwned:
    "Esta senha já apareceu em vazamentos conhecidos. Escolha outra mais segura.",
  form_password_not_strong_enough: "Senha muito fraca. Misture letras, números e símbolos.",
  form_param_format_invalid: "Formato inválido — confira o e-mail digitado.",
  form_param_nil: "Preencha todos os campos obrigatórios.",

  form_code_incorrect: "Código incorreto. Confira e tente novamente.",
  verification_expired: "O código expirou. Peça um novo envio.",
  verification_failed: "Não conseguimos verificar o código. Tente novamente.",
  verification_already_verified: "Este código já foi utilizado.",

  ticket_invalid_code: "Este convite não é mais válido. Peça um novo convite ao administrador da clínica.",
  ticket_expired_code: "Este convite expirou. Peça um novo convite ao administrador da clínica.",

  too_many_requests: "Muitas tentativas consecutivas. Aguarde um minuto e tente de novo.",
  captcha_invalid: "A verificação de segurança falhou. Recarregue a página.",
  network_error: "Sem conexão com o servidor. Confira sua internet e tente de novo.",

  oauth_access_denied: "Você cancelou a autorização do Google.",
  authorization_invalid: "O login com o Google não foi concluído. Tente novamente.",
  oauth_token_exchange_error: "O Google não confirmou o login. Tente novamente.",
  external_account_not_found: "Nenhuma conta associada a este Google. Crie uma conta primeiro.",
  external_account_exists: "Esta conta Google já está associada a outro usuário.",
};

type ErroClerk = {
  errors?: Array<{ code?: string; longMessage?: string; message?: string }>;
  code?: string;
  longMessage?: string;
  message?: string;
};

export function codigoDoErro(err: unknown): string | undefined {
  const e = err as ErroClerk;
  return e?.errors?.[0]?.code ?? e?.code;
}

export function mensagemDoErro(err: unknown): string {
  const e = err as ErroClerk;
  const codigo = codigoDoErro(err);
  if (codigo && EM_PORTUGUES[codigo]) return EM_PORTUGUES[codigo];

  const primeiro = e?.errors?.[0];
  return (
    primeiro?.longMessage ??
    primeiro?.message ??
    e?.longMessage ??
    e?.message ??
    "Ocorreu um erro ao processar. Tente novamente em instantes."
  );
}
